module.exports = __webpack_public_path__ + "img/image06.6fe16e03.jpg";